import {getDefaultPowerSourcesData, IPowerSource} from '../../../data/data';
import * as _ from 'lodash';
import {AnyAction} from 'redux';
import {CLEAR_ALL_DEPRECATIONS, CLEAR_SELECTED_LOCATION, REMOVE_POWER_SOURCE, SET_INITIAL_DEPRECATIONS} from '../../actions/action';
import {createSelector} from 'reselect';

export const getDeprecate = state => state.deprecate;
const getLocationID = (state, props: { location_id: number }) => props.location_id;


/**
 * check whether the power source at a location has been deprecated by an event
 */
export const isPowerSourceDeprecated = createSelector(

    [getDeprecate, getLocationID],

    (deprecate: boolean[], location_id: number) : boolean =>
    {
        return deprecate[location_id] === true;
    }
);


export const getDeprecations = (state) => state.deprecate;


const initial_state: boolean[] = _.fill(Array(50), undefined);


/**
 * reducer: keep track of which stations are deprecated
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function deprecate(state = initial_state, action: AnyAction) : typeof initial_state
{
    switch (action.type)
    {
        case CLEAR_ALL_DEPRECATIONS:
        {
            return initial_state.slice(0);
        }

        case SET_INITIAL_DEPRECATIONS:
        {
            const {payload} = action;
            const {deprecations} = payload;

            // console.group('deprecate: SET_INITIAL_DEPRECATE');
            // console.log('deprecations', deprecations);
            // console.groupEnd();

            return deprecations;
        }

        case REMOVE_POWER_SOURCE:
        {
            const {payload} = action;
            const {location_id} = payload;

            return [
                ...state.slice(0, location_id),
                false,
                ...state.slice(location_id + 1)
            ];
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/power-sources/deprecate.ts